import { type BasicOption } from "../../ButtonsGroup/ButtonsGroupItem/ButtonsGroupItem";

export interface RegistrationOption extends BasicOption {}

export enum RegistrationOptions {
  Email = 1,
  Teams,
  Calendar,
}
